import React from 'react'
import { useTranslation } from 'react-i18next'
import { SidePanelSection } from 'components/SidePanel/SidePanelSection'
import { SidePanelRowProps, SidePanelSummary } from 'components/SidePanel/SidePanelSummary'
import { getCustomerAddress } from 'pages/Customers/helpers/utils'
import { EmbeddedBusinessCustomer, EmbeddedCustomerEntityDetailsProps } from '../helpers/types'

export const BusinessCustomer = ({
  customer: company,
  sharedCustomerDetails,
}: EmbeddedCustomerEntityDetailsProps<EmbeddedBusinessCustomer>) => {
  const { t } = useTranslation()
  const { address } = company || {}

  const customerDetailsRows: SidePanelRowProps[] = [
    ...sharedCustomerDetails,
    { label: t('businessName'), content: company?.name },
    { label: t('industry'), content: company?.industry?.name },
    { label: t('customers.entityType'), content: company?.entityType },
    { label: t('businessRegistrationNumber'), content: company?.registrationNumber },
    { label: t('taxResidencyCountry'), content: company?.taxResidenceCountryCode },
    { label: t('address'), content: getCustomerAddress(address, { usePostalCode: true }) },
    { label: t('country'), content: address?.country },
  ]

  return (
    <SidePanelSection heading={t('embeddedCustomers.details.customerDetails')}>
      <SidePanelSummary rows={customerDetailsRows} />
    </SidePanelSection>
  )
}
